import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuDivider, MenuGroup, MenuItem } from '@sgi/gravity';
import { useCallback } from 'react';
import { useRenderedUserMenuItems, useUserMenuItems } from '../../../../../shell';
import UserLocation from './UserLocation';
export default function AppUserMenu() {
    const userMenuItems = useUserMenuItems();
    const renderMenuGroup = useCallback((category, userMenuItems) => {
        return (_jsxs(_Fragment, { children: [_jsx(MenuGroup, { title: category, children: userMenuItems?.map(userMenuItem => _jsx(MenuItem, { children: userMenuItem.component })) }), _jsx(MenuDivider, {})] }));
    }, []);
    const renderedNavigationItems = useRenderedUserMenuItems(userMenuItems, renderMenuGroup);
    return (_jsxs(_Fragment, { children: [_jsx(UserLocation, {}), _jsx(_Fragment, { children: renderedNavigationItems })] }));
}
